import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import { useMsal } from "@azure/msal-react";

import Header from './Header';
import Footer from './Footer';
import SideMenu from './SideMenu';
import idleTimer  from '../components/Helper/idleTimer';

const Content = styled.div`
 padding: 1rem;

@media (max-width: 1390px) {
    padding: 1rem;
}
@media (max-width: 1200px) {
    padding: 1rem ;
    margin: 0 1rem;
}

`;

const ContentWrapper = styled.div`
background:#FFF;
@media (min-width: 1200px) {
    padding: 0 1rem 0 1rem ;
}
@media (min-width: 1420px){
    margin: 0 0 0 0rem ;
}
@media (max-width: 1600px){
    padding: 0 0 0rem 0rem ;
}
@media (max-width: 1200px) {
    padding: 0 0 0 0 ;
}
@media (min-width:1200px ) and (max-width: 1400px) {
    padding: 0 0 1rem 2rem ;
}
@media (min-width: 1900px) and (max-width: 2200px){
    margin: 0 0 0 0rem ;
}
@media (min-width: 2200px) and (max-width: 2400px){
    margin: 0 0 0 0rem ;
}
@media (min-width: 2400px) and (max-width: 2600px){
    margin: 0 0 0 0rem ;
}
@media (min-width: 2600px){
    margin: 0 0 0 0rem ;
}
`;

const HomeLayout = props => {
    const { children } = props;
    const { instance } = useMsal();
    useEffect(()=>{
        idleTimer(instance);
    },[])
    return (
        
    <ContentWrapper style={{padding: 0}}>
        <Grid container>
            <Grid style={{marginTop:"69px"}} item xs={12} sm={12} md={12} xl={12} lg={12} >
                <Header/>
                <div className='content-wrapper'>
                <Content role="main" style={{padding: 0, minHeight: '90vh'}}>
                {children}
                </Content>
                </div>
                <Footer/>
            </Grid>
        </Grid>
    </ContentWrapper>
      

    );
}

HomeLayout.propTypes = {
    children: PropTypes.node.isRequired
}
export default HomeLayout;
